<template>
  <div class="card-mode">
    <dsf-platform-card-box
      ref="cardBox"
      :data="data"
      :column-number="layoutInfo.columnNumber"
      :column-width="layoutInfo.columnWidth"
      :margin-top="layoutInfo.marginTop"
      :checkbox-style="layoutInfo.checkboxStyle"
      :checkbox-size="layoutInfo.checkboxSize"
      :checkbox-position="layoutInfo.checkboxPosition"
      :checkbox="checkboxColumn.show"
      :max-check-num="isSingleChecked ? 1 : 0"
      :selectable="selectable"
      @select="select"
      @select-all="selectAll"
      @on-contextmenu="onContextmenu">
      <template #default="scope">
        <slot v-bind="scope"></slot>
      </template>
      <!-- <template v-if="!$list.isSingleChecked" #all-select="{owner}"> -->
      <template v-if="!$list.isSingleChecked && $list.isAllPageSelect" #all-select="{owner}">
        <el-popover placement="right" width="110" trigger="hover" popper-class="ds-datagrid-isallselected-popover">
          <template #reference>
            <dsf-custom-checkbox
              class="ds-platform-card-box-checkAll"
              :class="[owner.checkboxSize]"
              :value="isAllSelected || owner.checkAll"
              :indeterminate="owner.isIndeterminate"
              size="small"
              @change="defaultSelectAll(owner, $event)">
              全选
            </dsf-custom-checkbox>
          </template>
          <template #default>
            <el-row>
              <el-col :span="9">
                <el-checkbox
                  :disabled="isAllSelected"
                  :indeterminate="owner.isIndeterminate"
                  :value="isAllSelected || owner.checkAll"
                  @click.native.s.stop
                  @change="owner.handleCheckAllChange($event)"
                />
              </el-col>
              <el-col :span="15">当前页</el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-checkbox
                  v-model="isAllSelected"
                  :indeterminate="owner.isIndeterminate"
                  @click.native.s.stop
                />
              </el-col>
              <el-col :span="15">全部页</el-col>
            </el-row>
          </template>
        </el-popover>
      </template>
      <!-- <template v-if="!$list.isSingleChecked" #select="{owner, row}"> -->
      <template v-if="!$list.isSingleChecked && $list.isAllPageSelect" #select="{owner, row}">
        <dsf-custom-checkbox
          class="ds-platform-card-item-checkbox"
          :value="isAllSelected || owner.checkIdList.indexOf(row[owner.rowKey]) > -1"
          :style-type="owner.checkboxStyle"
          :size="owner.checkboxSize"
          :disabled="isAllSelected"
          @input="owner.checkChange(row, $event)"
        />
      </template>
    </dsf-platform-card-box>
  </div>
</template>

<script>
export default {
  name: "DsfDataGridCard",
  inject: {
    $list: {
      default: null
    }
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    layoutInfo: {
      type: Object,
      default() {
        return {
          columnNumber: 3, // 一行N列
          columnWidth: "30%", // 列宽
          marginTop: "15px", // 上下间隙
          checkboxStyle: "style1", // 选择框样式
          checkboxSize: "medium", // 选择框尺寸 big, medium, small
          checkboxPosition: "top right" // 选择框位置
        }
      }
    },
    // 是否显示checkbox列
    checkboxColumn: {
      type: Object,
      default() {
        return {
          show: true
        }
      }
    },
    // 是否仅单选
    isSingleChecked: {
      type: Boolean,
      default: false
    },
    // 仅对 type=selection 的列有效，类型为 Function，Function 的返回值用来决定这一行的 CheckBox 是否可以勾选
    // Function(row, index)
    selectable: {
      type: Function,
      default: null
    },
    // 是否滚动加载
    scrollLoad: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {

    };
  },
  computed: {
    isAllSelected: {
      get() {
        let {isAllPageSelect, isAllSelected} = this.$list;
        return isAllPageSelect && isAllSelected;
        // return this.$list.isAllSelected
      },
      set(val) {
        if (this.$list.isAllPageSelect) {
          val || this.$list.clearSelect();
          this.$emit('update:is-all-selected', val);
        }
      }
    },
  },
  watch: {
    "scrollLoad"(to) {
      if (to) {
        this.onScroll();
      } else {
        this.offScroll();
      }
    }
  },
  created() {
    this.emitScroll = e => {
      this.$emit('scroll', e);
    }
  },
  mounted() {
    if (!this.$list.isDesign && this.scrollLoad) {
      this.scrollBox = this.$el;
      this.onScroll();
    }
  },
  beforeDestroy() {
    this.offScroll();
  },
  methods: {
    onScroll() {
      this.scrollBox?.addEventListener('scroll', this.emitScroll);
    },
    offScroll() {
      this.scrollBox?.removeEventListener('scroll', this.emitScroll);
    },
    select(val, row) {
      this.$emit("select", val, row, this);
    },
    selectAll(val) {
      this.$emit("select-all", val, this);
    },
    onContextmenu(e) {
      this.$emit("on-contextmenu", e);
    },
    // 全选/全不选 事件
    handleCheckAllChange(val, isNotEmit) {
      this.$refs.cardBox.handleCheckAllChange(val, isNotEmit);
    },
    // 清空选项
    clearSelection() {
      this.$refs.cardBox.clearSelection();
    },
    // 切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
    toggleRowSelection(row, selected) {
      this.$refs.cardBox.toggleRowSelection(row, selected);
    },
    // 用于多选，切换所有行的选中状态
    toggleAllSelection() {
      this.$refs.cardBox.toggleAllSelection();
    },
    defaultSelectAll(owner, val) {
      if (this.isAllSelected) {
        this.isAllSelected = false;
      } else {
        owner.handleCheckAllChange(val)
      }
    }
  }
}
</script>